import { ADD_EXCEPTION, LOGIN_USER, LOGIN_USER_SUCCESS } from '../../constants/index.js';

/**
 * Fetch loading status reducer.
 * 
 * @param  {Boolean} state  The initial state.
 * @param  {String}  action The action to perform. 
 * @return {Object}
 */
export default function ( state = false, action )
{
	switch ( action.type )
	{
		case ADD_EXCEPTION:
			return false;

		case LOGIN_USER:
			return true;

		case LOGIN_USER_SUCCESS:
			return false;

		default:
			return state;
	}
}